export const URL_BASE_AUTH = 'https://back.sferafarma.cloud/api/v1'
export const URL_BASE_CORE = 'https://back.sferafarma.cloud/api/v1'
